<template lang="pug">
  app-modal(type="warning", v-model="value.isOpen", v-if="value.item")
    app-messages(:errorMessages="modalErrors")
    template(slot="title") エラー
    div {{value.item.message}}
    template(slot="footer", slot-scope="{close}")
      button.btn.btn-primary(type="button" @click="dlErrorLog(value.item)")
        i.fa.fa-download
        |  エラーログダウンロード
      button.btn.btn-default(type="button" @click="close") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'

export default {
  name: 'ListModalErrorJob',
  components: { AppModal, AppMessages },
  props: {
    /*
     * isOpen: 開閉状態
     * item: ジョブデータ
     */
    value: {
      type: Object,
      required: true,
      default: function () {
        return {
          isOpen: false,
          item: {}
        }
      }
    }
  },
  data: function () {
    return {
      modalErrors: []
    }
  },
  watch: {
    'value.isOpen': function (newValue, oldValue) {
      // 開いたときの初期設定
      this.resetData()
    }
  },
  methods: {
    resetData: function () {
      this.modalErrors = []
    },
    /**
     * エラーログ取得処理
     * @param item エラーになったジョブ
     */
    dlErrorLog: function (item) {
      const vm = this
      this.modalErrors = []
      // ダウンロード処理を行う
      this.getFileDL('appsuitejob', 'getErrorLogs', `appsuite_export_${item.id}.log`, item.id)
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/appsuitejobs/ListModalErrorJob.vue